import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
//i18n
import { useNavigate } from "react-router-dom"
import i18n from "i18n"
import { PoppinsNormal } from "common/typographies"
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown"

const DropdownSelectQuestion1 = ({
  value,
  setValue,
  referencia,
  dataTestid,
}) => {
  const [menu, setMenu] = useState(false)
  const navigate = useNavigate()
  return (
    <>
      <React.Fragment>
        <Dropdown
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          className="d-inline-block"
          id="dropDownWidth2"
          style={{ height: "0px", width: "100%", marginLeft: "20px" }}
        >
          <DropdownToggle
            data-testid={dataTestid}
            style={{
              marginTop: "0px",
              height: "35px",
              marginLeft: "-20px",
              marginBottom: "30px",
              borderRadius: "6px",
              border: "1px solid #c4c4c4",
              width: "95%",
              paddingLeft: "10px",
            }}
          >
            <div
              id="overflowInputDrop"
              className="inline"
              style={{ position: "relative" }}
            >
              <PoppinsNormal
                style={{
                  fontSize: "14px",
                  color: value.length > 0 ? "#414141" : "#C4C4C4",
                  lineHeight: "12px",
                  cursor: "pointer",
                  textTransform: "none",
                }}
              >
                {value.length > 0 ? value : i18n.t("Selecciona una opcion")}
              </PoppinsNormal>
              <KeyboardArrowDown
                style={{
                  color: "#414141",
                  width: "15px",
                  position: "absolute",
                  right: "5px",
                  marginTop: "-5px",
                }}
              />
            </div>
          </DropdownToggle>
          <DropdownMenu
            id="overflowDropdown"
            className="dropdown-menu-end"
            style={{ width: "95%", marginRight: "32px" }}
          >
            <DropdownItem
              tag="b"
              style={{ lineHeight: "20px", cursor: "pointer" }}
              onClick={() => {
                setValue("1")
              }}
            >
              {" "}
              <div className="inline">1</div>
            </DropdownItem>
            <DropdownItem
              tag="b"
              style={{
                lineHeight: "20px",
                cursor: "pointer",
                overflow: "hidden",
              }}
              onClick={() => {
                setValue("2-5")
              }}
            >
              {" "}
              <div className="inline">2-5</div>
            </DropdownItem>
            <DropdownItem
              tag="b"
              style={{ lineHeight: "20px", cursor: "pointer" }}
              onClick={() => {
                setValue("6-10")
              }}
            >
              {" "}
              <div className="inline">6-10</div>
            </DropdownItem>
            <DropdownItem
              tag="b"
              style={{ lineHeight: "20px", cursor: "pointer" }}
              onClick={() => {
                setValue("10 +")
              }}
            >
              {" "}
              <div className="inline">10 +</div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    </>
  )
}

DropdownSelectQuestion1.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  value: PropTypes.string,
  setValue: PropTypes.func,
  referencia: PropTypes.any,
  dataTestid: PropTypes.string,
}

export default DropdownSelectQuestion1
